var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImpressum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 15.75C8.66421 15.75 9 16.0858 9 16.5C9 16.9142 8.66421 17.25 8.25 17.25H4.5C4.08579 17.25 3.75 16.9142 3.75 16.5C3.75 16.0858 4.08579 15.75 4.5 15.75H8.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.75C12.4142 12.75 12.75 13.0858 12.75 13.5C12.75 13.9142 12.4142 14.25 12 14.25H4.5C4.08579 14.25 3.75 13.9142 3.75 13.5C3.75 13.0858 4.08579 12.75 4.5 12.75H12Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 0C12.1348 0 16.5 4.36522 16.5 9.75V19.125C16.5 20.1605 15.6605 21 14.625 21H1.875C0.839466 21 0 20.1605 0 19.125V1.875C0 0.839466 0.839466 0 1.875 0H6.75ZM1.875 1.5C1.66789 1.5 1.5 1.66789 1.5 1.875V19.125C1.5 19.3321 1.66789 19.5 1.875 19.5H14.625C14.8321 19.5 15 19.3321 15 19.125V10.125C15 8.67525 13.8247 7.5 12.375 7.5H10.875C9.83947 7.5 9 6.66053 9 5.625V4.125C9 2.67525 7.82475 1.5 6.375 1.5H1.875ZM10.0068 2.16895C10.321 2.75111 10.5 3.41706 10.5 4.125V5.625C10.5 5.83211 10.6679 6 10.875 6H12.375C13.0825 6 13.7482 6.17837 14.3301 6.49219C13.4966 4.55545 11.9437 3.00214 10.0068 2.16895Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpressum);
export default __webpack_public_path__ + "static/media/impressum.729c44393d8d363d858c67afe4dcf61a.svg";
export { ForwardRef as ReactComponent };